module.exports = __webpack_public_path__ + "media/img/android-icon-48x48-6ed08470c850bb5a9779c3d4a446be63.png";